import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import Moment from "moment";
import { Link, useSearchParams } from "react-router-dom";
import { Col } from "react-bootstrap";
import ShowSkeleton from "../utils/helpers/skeleton";
import ReactPaginate from "react-paginate";
import { editenquiry, getenquiryList } from "../store/slices/enquiry";
import { Modal, ModalBody } from "reactstrap";

const Enquiry = () => {
  const [data, setData] = useState([]);

  const [isloading, setisLoading] = useState(false);
  const itemsPerPage = 25;
  const dispatch = useDispatch();
  const [search, setSearch] = useSearchParams();
  const querypage = parseInt(search.get("page")) || 1;
  const [currentPage, setCurrentPage] = useState(querypage);
  const [totalData, setTotalData] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [updatestatus, setupdatestatus] = useState({
    id: "",
    status: "",
    comments: "",
  });
  const [selectedId, setSelectedId] = useState(null);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    setisLoading(true);
    getEnquiries();
  }, [currentPage]);

  const item = {
    limit: itemsPerPage,
    page: currentPage,
  };

  const handlePageChange = (event) => {
    const newPage = event.selected + 1;
    setCurrentPage(newPage);
    search.set("page", newPage);
    setSearch(search, { replace: true });
  };

  const handleCloseModal = () => {
    setSelectedId(null);
    setShowModal(false);
  };
  const handleOpenModal = (id) => {
    setShowModal(true);
    setSelectedId(id);
    setErrors({});
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatestatusnew = { ...updatestatus, id: selectedId, [name]: value };
    if (name === "status") {
      if (value !== "") {
        setErrors({});
      }
    }

    setupdatestatus(updatestatusnew);
  };

  const getEnquiries = () => {
    dispatch(getenquiryList(item))
      .unwrap()
      .then((data) => {
        setData(data?.enquiryData);
        setTotalData(data?.totalDataCount);
      })
      .catch(({ message }) => console.error(message))
      .finally(() => {
        setisLoading(false);
      });
  };
  const totalPages = Math.ceil(totalData / itemsPerPage);

  const editEnquiry = () => {
    const updatestatusnew = { ...updatestatus, id: selectedId };
    console.log("edit enquiry called", updatestatusnew);
    if (updatestatus.status === "") {
      setErrors({ status: "Status is required." });
      return; // Stop function execution
    }

    dispatch(editenquiry(updatestatusnew))
      .unwrap()
      .then((data) => {
        console.log("edit enquiry", data?.enquiry?.data);
      })
      .catch(({ message }) => console.error(message))
      .finally(() => {
        getEnquiries();
        handleCloseModal();
      });
  };

  return (
    <>
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
        <h6 className="fw-semibold mb-0">Enquiry</h6>
        <ul className="d-flex align-items-center gap-2">
          <li className="fw-medium">
            <Link
              to="/admin/home"
              className="d-flex align-items-center gap-1 hover-text-primary"
            >
              Home
            </Link>
          </li>
          <li> &gt;</li>
          <li className="fw-medium">Enquiry </li>
        </ul>
      </div>
      <div className="card h-100 p-0 radius-12">
        <div className="card-header  bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
          <div className="d-flex align-items-center flex-wrap gap-3"></div>
        </div>
        <div className="card-body px-24 py-2">
          <div className="table-responsive scroll-sm">
            {isloading ? (
              <Col lg={12} xs={12} md={12} align="center">
                {ShowSkeleton()}
              </Col>
            ) : (
              <table className="table striped-table mb-0">
                <thead>
                  <tr>
                    <th scope="col">
                      <div className="d-flex align-items-center gap-10">
                        S.L
                      </div>
                    </th>
                    <th scope="col">Enquiry Date</th>
                    <th scope="col">User Details</th>

                    <th scope="col">Enquiry For</th>
                    <th scope="col">No. of Pax</th>
                    <th scope="col" className="text-center">
                      Status
                    </th>
                    <th scope="col" className="text-center">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr key={index}>
                      <td>
                        <div className="d-flex align-items-center gap-10 text-md">
                          {(currentPage - 1) * itemsPerPage + index + 1}
                        </div>
                      </td>
                      <td className="text-md">
                        {Moment.utc(item?.created_at).format("DD-MM-YYYY")}
                      </td>

                      <td>
                        <div className="d-flex align-items-center">
                          <div className="flex-grow-1">
                            <span className="text-md mb-0 fw-normal text-secondary-light">
                              <b>Name:</b> {item.name}
                              <br />
                              <b>Email:</b> {item.email}
                              <br />
                              <b>Mobile Number:</b> {item.contactNumber}
                            </span>
                          </div>
                        </div>
                      </td>

                      <td style={{ width: "200px" }} className="text-md">
                        {item.enquiryFor === "Travel Package" && (
                          <p>{item?.travelpackageId?.packageName}</p>
                        )}
                      </td>
                      <td className="text-md">
                        {item.adult} {item.adult > 1 ? "Adults" : "Adult"}
                        <br />
                        {item.child > 0 && (
                          <>
                            {item.child} {item.child > 1 ? "Children" : "Child"}
                          </>
                        )}
                      </td>

                      <td className="text-center">
                        <div className="d-flex align-items-center gap-10 justify-content-center">
                          {item.status}
                        </div>
                      </td>
                      <td className="text-center">
                        <div className="d-flex align-items-center gap-10 justify-content-center">
                          <button
                            onClick={() => handleOpenModal(item.id)}
                            className="btn btn-primary-600 wd-130 radius-8 px-8 text-sm py-6 "
                          >
                            Update Status
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
          <div>
            <Modal isOpen={showModal} toggle={handleCloseModal} centered>
              <ModalBody className="d-flex flex-column justify-content-center ">
                <h6>Update Status</h6>

                <form autoComplete="off">
                  <div>
                    <label className="form-label">
                      Status <span className="text-danger">*</span>
                    </label>
                    <select
                      name="status"
                      value={updatestatus.status}
                      onChange={handleChange}
                      className="form-control"
                    >
                      <option value="">Select</option>
                      <option value="FollowUp">FollowUp</option>
                      <option value="Not Interested">Not Interested</option>
                    </select>
                    {errors.status && (
                      <div className="text-danger">{errors.status}</div>
                    )}
                  </div>
                  <div>
                    <label className="form-label">
                      Comments <span className="text-danger"></span>
                    </label>
                    <textarea
                      name="comments"
                      value={updatestatus.comments}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="Enter Comments"
                      rows="4"
                      // style={{ width: "100%", resize: "vertical" }}
                    />
                  </div>
                </form>
                <div className="d-flex justify-content-end gap-2 mt-3">
                  {" "}
                  {/* Align buttons to right */}
                  <button
                    className="btn btn-outline-primary-600 radius-8 wd-100 px-14 py-6 text-md"
                    onClick={handleCloseModal}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary-600 radius-8 wd-100 px-14 py-6 text-md"
                    onClick={editEnquiry}
                  >
                    Update
                  </button>
                </div>
              </ModalBody>
            </Modal>
          </div>
          <div className="d-flex justify-content-between mt-3">
            <span>&nbsp;</span>
            <ReactPaginate
              previousLabel={"«"}
              nextLabel={"»"}
              breakLabel={"..."}
              pageCount={totalPages}
              marginPagesDisplayed={1}
              pageRangeDisplayed={3}
              onPageChange={handlePageChange}
              containerClassName={"pagination"}
              activeLinkClassName={"active"}
              previousClassName={"previous"}
              nextClassName={"next"}
              disabledClassName={"disabled"}
              pageLinkClassName={"page-link"}
              previousLinkClassName={"page-link"}
              nextLinkClassName={"page-link"}
              breakLinkClassName={"page-link"}
              forcePage={currentPage - 1}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Enquiry;
